import React from 'react';
import forbiddenImage from '../../assets/images/static/403.svg';
import notFound from '../../assets/images/static/404.svg';

const NotFound = ({ status }) => {
  if (status === 404) {
    return (
      <div className="dashboard-content">
        <img className="image" src={notFound} alt="Dashboard" />
        <span className="">Sayfa bulunamadı.</span>
      </div>
    );
  }

  return (
    <div className="dashboard-content">
      <img className="image" src={forbiddenImage} alt="Dashboard" />
      <span className="">Bu sayfaya yetkiniz bulunmamaktadır.</span>
    </div>
  );
};

export default NotFound;
